import type { InstagramContactIdentity } from '../services/instagram.ts';

interface DisplayContact {
  id: number;
  name?: string;
  photo?: string;
  active_channel?: string | null;
  source_channel?: string | null;
  instagram_identity_id?: number | null;
  instagram_username?: string | null;
}

/** Profile metadata belongs only to the authenticated conversation that returned it. */
export function instagramContactDisplay<T extends DisplayContact>(contact: T, identity: InstagramContactIdentity | null): T & { instagram_clinic_username?: string | null } {
  if (!identity || contact.id !== identity.contact_id
    || (contact.active_channel || contact.source_channel) !== 'instagram'
    || (contact.instagram_identity_id && contact.instagram_identity_id !== identity.identity_id)) return contact;
  const defaultName = !contact.name || contact.name === 'Contato Instagram'
    || (contact.instagram_username && contact.name === `@${contact.instagram_username}`);
  return { ...contact,
    name: defaultName ? (identity.name || contact.name) : contact.name,
    photo: identity.photo || contact.photo,
    instagram_username: identity.username || contact.instagram_username,
    instagram_clinic_username: identity.clinic_username,
  };
}

export function instagramProfileLabel(username?: string | null, clinicUsername?: string | null): string {
  const contact = username ? `@${username.replace(/^@/, '')}` : 'Instagram';
  return clinicUsername ? `${contact} · Clínica @${clinicUsername.replace(/^@/, '')}` : contact;
}
